export default "__VITE_ASSET__BJIk2pi6__"